import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { useLocalization } from '@shared-ui/localization-context';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import { AvailabilityWizard } from 'components/infosite/rooms-and-rates/availability-wizard';
import { SharedUiDatedForm } from 'components/infosite/shared-ui/form/shared-ui-forms';
export const SearchWizardComposer = ({
  isMultiItem,
  onUpdateResults,
  onUpdateResultsAvailabilityWizard
}) => {
  const {
    formatText
  } = useLocalization();
  const availabilityWizardProps = {
    currentHotelOnly: true,
    onUpdateResults: onUpdateResultsAvailabilityWizard
  };
  if (isMultiItem) {
    return null;
  }
  return React.createElement(Viewport, null, React.createElement(ViewSmall, null, React.createElement(AvailabilityWizard, Object.assign({}, availabilityWizardProps))), React.createElement(ViewLarge, null, React.createElement(React.Fragment, null, React.createElement(ErrorBoundary, {
    label: "hotel.information.rooms.availabilityWizard"
  }, React.createElement("div", {
    "data-stid": "section-hotel-search"
  }, React.createElement("h3", {
    className: "is-visually-hidden"
  }, formatText('hotels.infosite.availabilityWizard.changeSearch.a11yLabel')), React.createElement(SharedUiDatedForm, {
    onChange: criteria => onUpdateResults(null, criteria, false)
  }))))));
};
SearchWizardComposer.displayName = 'SearchWizardComposer';